import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import _ from 'underscore';
import { AdAssetsFormShimmer, AdAssetsPreviewerShimmer } from '@bingads-webui-campaign-react/pmax-lite-shimmers';
import { getAssetsPanels } from '@bingads-webui-campaign-react/unified-app-shared';
import { useWizardService } from '@bingads-webui-react/wizard';

import { AssetsStepForm } from './components';
import { useAssetsStepStyles } from './use-assets-step-styles';

export const AssetsStepShell = (props) => {
  const { data } = props || {};

  const isLoading = useMemo(() => _.isEmpty(data), [data]);
  const getStyles = useAssetsStepStyles();

  const { state } = useWizardService();

  const {
    wizardData: { flow },
  } = state.context;

  const assetPanels = useMemo(() => getAssetsPanels(flow), [flow]);

  return (
    <>
      {
        isLoading ?
          <div className={getStyles('container')}>
            <div className={getStyles('formContainer')}>
              <AdAssetsFormShimmer />
            </div>
            <div className={getStyles('previewerContainer')}>
              <AdAssetsPreviewerShimmer />
            </div>
          </div>
          : <AssetsStepForm
              assetPanels={assetPanels}
              {...props}
          />
      }
    </>
  );
};

AssetsStepShell.propTypes = {
  data: propTypes.shape({}),
};

AssetsStepShell.defaultProps = {
  data: {},
};
